export default __webpack_public_path__ + "static/media/default_gray@1x.81741081.jpg";